import { FEATURE_TYPE, MapSelectAssetType } from "./map-library";

export class SclMapConstantService {
  static MAP_PRIMARY_ASSET = 'https://fileshare.formbird.com/fb/sc-component/map-icons/primary.png';
  static MAP_SECONDARY_ASSET = 'https://fileshare.formbird.com/fb/sc-component/map-icons/secondary.png';
  static MAP_MARKER = 'https://fileshare.formbird.com/fb/sc-component/map-icons/marker.png';
  static AVL_SPEED_BEGINNING = 'https://fileshare.formbird.com/fb/sc-component/map-icons/pin30';
  static HEADING_THRESHOLD_H0 = 22.5;
  static HEADING_THRESHOLD_H1 = 67.5;
  static HEADING_THRESHOLD_H2 = 112.5;
  static HEADING_THRESHOLD_H3 = 157.5;
  static HEADING_THRESHOLD_H4 = 202.5;
  static HEADING_THRESHOLD_H5 = 247.5;
  static HEADING_THRESHOLD_H6 = 292.5;
  static HEADING_THRESHOLD_H7 = 337.5;
  static DEFAULT_SEARCH_DELAY = 500;
  static DEFAULT_SEARCH_LENGTH = 3;
  static AVL_SPEED_H0 = '_h0';
  static AVL_SPEED_H1 = '_h1';
  static AVL_SPEED_H2 = '_h2';
  static AVL_SPEED_H3 = '_h3';
  static AVL_SPEED_H4 = '_h4';
  static AVL_SPEED_H5 = '_h5';
  static AVL_SPEED_H6 = '_h6';
  static AVL_SPEED_H7 = '_h7';
  static EPSG_3857 = 'EPSG:3857';
  static EPSG_4326 = 'EPSG:4326';
  static MAP_MARKER_ARROW = 'https://fileshare.formbird.com/fb/sc-component/map-icons/arrow.png';
  static MAP_MARKER_CROSS_GREEN = 'https://fileshare.formbird.com/fb/sc-component/map-icons/CrosshairGreen.gif';
  static STREET = {
    type: FEATURE_TYPE.FEATURE,
    properties:{
      type: MapSelectAssetType.STREET,
      unitNo: '',
      streetNo: '',
      street: '',
      suburb: '',
      postcode: '',
      locationDescription: '',
      country: '',
      iconImage: '',
      iconSize: '',
      state: ''
    },
    geometry:{
      type: 'Point',
      coordinates:[]
    }
  }; // 15925
  
  
  

  static DEFAULT_MAP_PARAMETERS = { 
    mapViews: [
      {
        serverType: 'tile',
        url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
        crossOrigin: null
      }
    ] 
  }; // 15754
}
